import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { API_SERVER_URL } from '@/constants/Config';

/**  Endpoint to fetch and post Braintree related work.  */
export const braintreePaypalQuery = createApi({
  reducerPath: 'braintreePaypalQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: API_SERVER_URL,
  }),
  endpoints: (builder) => ({
    getBraintreeClientToken: builder.query({
      query: (userId?: number) => {
        const queryParams = userId ? `?userId=${encodeURIComponent(userId)}` : '';
        return {
          url: `api/braintree-paypal/client-token${queryParams}`,
          method: 'get',
        };
      },
    }),
  }),
});

export const { useLazyGetBraintreeClientTokenQuery } = braintreePaypalQuery;
